import React from 'react';
import { Box, Link } from '@mui/material';
import { HomeHeader, HomeFooter } from '../components/ui';
import {
  LandingHero,
  DecisionWalkthrough,
  ApplicationExamples,
  ForOrganizations,
  Differentiation,
  PricingOffers,
} from '../components/landing';

const Home = () => {
  return (
    <>
      <Link
        href="#main-content"
        sx={{
          position: 'absolute',
          left: -9999,
          top: 0,
          zIndex: 2000,
          bgcolor: 'background.paper',
          color: 'primary.dark',
          px: 2,
          py: 1,
          '&:focus': {
            left: 16,
            top: 16,
            outline: '2px solid #1565c0',
            outlineOffset: 2,
          },
        }}
      >
        Skip to main content
      </Link>
      <HomeHeader />
      <Box component="main" id="main-content">
        <LandingHero />
        <DecisionWalkthrough />
        <ApplicationExamples />
        <ForOrganizations />
        <Differentiation />
        <PricingOffers />
      </Box>
      <HomeFooter />
    </>
  );
};

export default Home;
